import { forwardRef } from 'react';
import { cx } from '@linaria/atomic';
import { boolInputBase, boolInputDisabled, boolInputEnabled } from './bool-input.styles';
import type { BoolInputKey, BoolInputProps } from './types';

export const BoolInput = forwardRef(
  <T extends BoolInputKey>(
    { trackingId, className, disabled, ...props }: BoolInputProps<T> & { className?: string },
    ref
  ) => {
    return (
      <input
        className={cx(boolInputBase, disabled ? boolInputDisabled : boolInputEnabled, className)}
        data-trackingid={trackingId}
        disabled={disabled}
        {...props}
        ref={ref}
      />
    );
  }
);
